import React, { useState } from "react";

import Slider from "react-slick";

// img
import ImgAboutUs from "../../assets/Home/aboutUs/imgAboutUs2.png";
import ImgAboutUs1 from "../../assets/Home/aboutUs/imgAboutUs3.png";
import ImgAboutUs2 from "../../assets/Home/aboutUs/imgAboutUs4.png";
import ImgAboutUs3 from "../../assets/Home/aboutUs/imgAboutUs5.png";

import { Wrapper, TitleCarousel } from "./styled";
import { Box, Flex } from "@edricphan2022/uikit";
import { Text } from "@edricphan2022/uikit";
import Picture from "../Picture";
import styled from "styled-components";

//icon

const ArrDemo = [
  {
    url: ImgAboutUs,
    title: `Fintech, Blockchain and A Trusted Development Technology Team`,
    des: `Orbit has been established by a team of Blockchain programming experts and a real passion for this Field.`,
    des2:`Orbit team brings to our customer the best solution to solve Development and Design problems with reasonable cost but still effectively and smart to bring your users best experience.`,
  },
  {
    url: ImgAboutUs1,
    title: `Cost-saving Blockchain Development`,
    title2: '',
    des: `Blockchain is a unique opportunity for financial institutions, changing our lives in profound ways and unleashing a set of new capabilities to transform the way we interact and collaborate in our activities with better security and better authenticity of files.`,
    des2:'',
  },
  {
    url: ImgAboutUs2,
    title: `Private Blockchain Platforms`,
    title2: '',
    des: `Recently the concept of private blockchains has become popular within the discussions on blockchain technology, particularly among financial institutions.`,
    des2:`Instead of having a fully decentralized network open to the public with anonymous parties, it is possible to create a system where each party is identified and granted permissions to change or read the blockchain.`
  },
  {
    url: ImgAboutUs3,
    title: `Fast-Track Application Tutorial`,
    title2: '',
    des: `We introduced the smart contract programming language and tools that make it simple and easy to fast-track deploy a smart contract to the base blockchain.`,
    des2:'In the next chapter, we will introduce tools that are a little more complex and support a development workflow to handle more complex situations.',
  },
];

const Carousel = () => {
  const [isShow, setIsShow] = useState(true);

  const handleClose = () => {
    setIsShow((close) => !close);
  };

  const settingsCard: any = {
    dotsClass: "slick-dots-card slick-thumb-card",
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <Wrapper>
      <Slider {...settingsCard}>
        {ArrDemo.map((_item, _index) => (
          <Box key={`ArrDemo-${_index}`} >
            <BoxElement marb = {_item.title2 === ''} >
              <Box className='Home-About-Img'  >
                <Picture url={_item.url} />
              </Box>
              <Box className='Home-About-Text'>
                <h3>{_item.title}</h3>
                {_item.title2 === '' ? '' : <h3>{_item.title2}</h3>}
                <p>{_item.des}</p>
                <p className='Home-About-Text-last' >{_item.des2}</p>
              </Box>
            </BoxElement>
          </Box>
        ))}
      </Slider>
    </Wrapper>
  );
};

const BoxElement = styled(Flex)<{marb ?: boolean}>`
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  .Home-About-Img {
    width: 49%;
  }
  .Home-About-Text{
    width: 49%;
    p{
      margin-top: 30px;
      font-size: 20px;
      font-weight: 400;
      font-family: ManropeRegular;
      line-height: 22px;
    }
    .Home-About-Text-last{
      margin-top: 30px;
    }
    h3{
      font-size: 34px;
      line-height: 54px;
      font-family: ManropeBold;
      color: #303031;
      max-width: 763px;
    }
  }
  @media only screen and (max-width: 1279px){
    .Home-About-Text{
      h3{
        margin-bottom: 20px;
        line-height: 40px;
      }
      .Home-About-Text-last{
        margin-top: 15px;
      }
    }
  }
  @media only screen and (max-width: 1132px){
    .Home-About-Text{
      p{
        font-size: 14px;
        line-height: 15px;
      }
      h3{
        font-size: 24px;
        line-height: 26px;
      }
    }
  }
  @media only screen and (max-width: 743px){
    flex-direction: column;
    .Home-About-Img{
      width: 100%;
    }
    .Home-About-Text{
      width: 100%;
      p{
        display: none;
      }
      h3{
        margin-top: 15px;
      }
    }
    .slick-dots-card{
      padding: 0px;
    }
  }
`

export default React.memo(Carousel);
